package com.example.mystybag.appCore.views.addMerchantLocation

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.systemBars
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.appCore.logic.addMerchantLocation.MerchantRegistrationReviewStoreDetailsViewModel
import com.example.mystybag.common.extensions.noRippleClickable
import com.example.mystybag.common.ui.components.native.DefaultButton
import com.example.mystybag.common.ui.components.native.DefaultButtonType
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p10
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p18
import com.example.mystybag.core.ui.theme.LocalTheme.p40
import com.example.mystybag.core.ui.theme.LocalTheme.p48
import com.example.mystybag.core.views.AppTheme
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource
import androidx.compose.foundation.shape.RoundedCornerShape
import com.example.mystybag.core.ui.theme.LocalTheme.p20
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p8

@Composable
expect fun MerchantRegistrationReviewStoreDetailsMapView(
    modifier: Modifier,
    latitude: Double?,
    longitude: Double?,
    onLocationChanged: (Double, Double) -> Unit,
    onMapReady: () -> Unit,
    searchPlaceHolder: String
)

@Composable
fun MerchantRegistrationReviewStoreDetailsView(viewModel: MerchantRegistrationReviewStoreDetailsViewModel) {
    val state = viewModel.uiState.subscribeAsState()

    UIView(
        modifier = Modifier.fillMaxSize(),
        viewModel = viewModel,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Column(modifier = Modifier.fillMaxSize()) {
            MerchantRegistrationReviewStoreDetailsMapView(
                modifier = Modifier
                    .weight(1f)
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(topStart = p40, topEnd = p40)),
                latitude = state.value.latitude,
                longitude = state.value.longitude,
                onLocationChanged = { lat, lng ->
                    viewModel.updateLocation(lat, lng)
                },
                onMapReady = { viewModel.onMapReady() },
                searchPlaceHolder = stringResource(SR.strings.merchant_location_map_search_hint)
            )
            Spacer(modifier = Modifier.height(p24))
            DefaultButton(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = p16),
                type = DefaultButtonType.PRIMARY,
                caption = stringResource(SR.strings.continue_camel_case),
                callback = viewModel::onContinue
            )
        }
    }
}

